export default __webpack_public_path__ + "static/media/PIA.64711743.png";